import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FileText } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function InfoPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) {
    return (
      <div className="container-store py-20 text-center" data-testid="info-page-missing">
        <Seo title="Página não encontrada | HG Móveis" noindex />
        <p className="font-heading text-2xl font-bold text-gray-900">Página não encontrada</p>
        <Link to="/" className="text-brand font-semibold text-sm mt-2 inline-block hover:underline">Voltar para a loja</Link>
      </div>
    );
  }
  if (!page) {
    return <div className="container-store py-16"><div className="animate-pulse h-40 bg-gray-50 rounded-2xl" /></div>;
  }

  return (
    <div className="container-store py-10 sm:py-14 max-w-3xl" data-testid="info-page">
      <Seo
        title={`${page.title} | HG Móveis`}
        description={page.content.split("\n")[0].slice(0, 160)}
        canonical={`/pagina/${page.slug}`}
      />
      <nav className="text-xs text-gray-400 mb-4">
        <Link to="/" className="hover:text-brand">Início</Link> <span className="mx-1">›</span> {page.title}
      </nav>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight flex items-center gap-3">
        <FileText className="w-8 h-8 text-brand shrink-0" /> {page.title}
      </h1>
      <div className="mt-6 bg-white border border-gray-100 rounded-2xl p-6 sm:p-8">
        {page.content.split("\n").filter(Boolean).map((line, i) => (
          <p key={i} className="text-gray-700 leading-relaxed mb-3 last:mb-0 text-[15px]">{line}</p>
        ))}
      </div>
    </div>
  );
}
